import type { TagsStore } from '.';
import { Paths } from '../constants';
import { apiInvoke, shouldLoad } from '../helpers/load';
import type { APILoadParams } from '../helpers/types';
import type { Tag } from '@/shared/types/tag';

export async function loadTags(
  { state, dispatch }: TagsStore,
  { force, api, auth }: APILoadParams,
) {
  if (!shouldLoad(state.loaded, force, auth)) {
    return;
  }

  const res = await apiInvoke<LoadTagsResponse>(api, Paths.tags, auth);
  dispatch({ type: 'setTags', data: res });
}

type LoadTagsResponse = Tag[];
